import React, { Component } from 'react';
import { Box, Drawer } from '@mui/material';
import { object, bool } from 'prop-types';

import CloseButton from '../CloseButton';
import SettingsForm from './SettingsForm';
import connector from './connector';

class SettingsDrawer extends Component {
  handleClose = () => {
    const { actions } = this.props;
    actions.drawers.settings.close();
  };

  render() {
    const { isOpen } = this.props;

    return (
      <Drawer anchor="right" open={isOpen} onClose={this.handleClose}>
        <Box sx={{ display: 'flex', height: '100%' }}>
          <Box sx={{ pt: '20px', pl: '20px' }}>
            <CloseButton onClick={this.handleClose} />
          </Box>
          <SettingsForm />
        </Box>
      </Drawer>
    );
  }
}

SettingsDrawer.propTypes = {
  actions: object.isRequired,
  isOpen: bool.isRequired,
};

export default connector(SettingsDrawer);
